import { useHookstate } from "@hookstate/core";
import { readerSettingsStore } from "../../../hookstate/readerSettingsStore";

export function usePageLayout() {
  const pageLayout = useHookstate(readerSettingsStore.pageLayout).get();

  const setPageLayout = (layout: string) => {
    readerSettingsStore.pageLayout.set(layout);
  };

  return { pageLayout, setPageLayout };
}
